
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"
import App from "../components/appStartkit";

import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const IndexPage = () => (
  <Layout2>
        <Breadcrumb category={["nyheter", "nyheter"]}  page={["Skratta och må bättre", "skratt"]}/>
    <SEO title="Skratta och må bättre" description="Skratta och var glad" keywords={[`Skratta`, `Tandblekning`, `Leende`, `Glad`, `Må bra`]} />
     
     <section className="section-metoder">
     <main>
       <h1 class="welcome">Hur många gånger skrattar du per dag? </h1>
       <p class="text-center">
      Visste du att leenden och skratt gör dig gladare, friskare, kreativare och mindre stressad? 
      Det sägs att ett gott skratt förlänger livet, och forskningen stödjer det påståendet. 
      Vi mår bättre, både psykiskt och fysiskt, när vi skrattar. 
      Enligt Stuart Robertshaw, psykologiprofessor och grundare av National Association for the 
      Humor Impaired i USA, är skrattet viktigare än vi tror. </p>
<p class="text-center">        
- Skratt stärker dig och gör både dig och din omgivning gladare. Om man kan se på vardagen med ett leende och släppa loss och skratta åt eländet även när det inte blir som man tänkt sig har man kommit långt. Ur skrattet kommer kraft att ta itu med det som behöver göras, säger Stuart Robertshaw.
</p><p class="text-center"> 
När vi skrattar masseras kroppens inre organ, syreupptagningen ökar, blodcirkulationen stimuleras och hjärtat slår snabbare. Kroppen producerar också hormoner som dämpar stress, oro och smärta och ökar välbefinnandet. Därför ökar vår stresstålighet och immunförsvaret stärks av ett skratt.
</p><p class="text-center"> 
- När syretillförseln till hjärnan ökar blir balansen mellan hjärnhalvorna bättre. Det gör att inlärnings- och problemlösningsförmågan förbättras och kreativiteten ökar. Efter skrattet sjunker blodtrycket, musklerna slappnar av och kropp och psyke vilar ut och mår bra, menar Dr Humor.  
</p>
</main>
</section>
<section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>
  <section className="section-metoder">
     <main>

<h3 class="welcome">Träna upp dig</h3> 
<p class="text-center"> 
Man kan faktiskt träna sig på att skratta. Små barn skrattar eller ler 400 gånger per dag, medan 35-åringar bara gör det futtiga femton gånger om dagen. Så dra nytta av dina egna eller andras barn. Busa och skratta med dem så ofta du får chansen.  
</p><p class="text-center"> 
- Börja varje dag med lite humor. Ta på er roliga hattar, köp clown-näsor till hela familjen eller lyssna på en skratt-CD (ja, de finns faktiskt att få tag på). Det låter lite larvigt, men det kommer garanterat att få er att skratta, säger skrattdoktorn.
</p><p class="text-center"> 
Dr Humor har själv övat upp sin förmåga att skratta och är uppe i över 400 skratt om dagen. Hans personliga skrattrekord är arton minuter. 
 </p><p class="text-center"> 
- Vi vuxna glömmer ofta vilken underbar gåva humor är. Vi tyngs av krav, stress och dåligt samvete och blir ibland alldeles för allvarliga för vårt eget bästa. Skratta med arbetskompisarna, familjen och för dig själv - det gör livet roligare att leva!
</p>

          </main>
          </section>
              <section className="section-cards">
      <main className="card__ai">
        <h2 class="card-rubrik">Startkit</h2>
        <h3 class="card__smRubrik">Bästa tandblekningen hemma</h3>
        <App />
        </main>
      </section>
      <section className="section-metoder">
      <main>
          <h3 class="welcome">Våra bästa tips</h3>
        <p class="text-center"> 

</p><p class="text-center"> 
<h5 class="welcome">Bit</h5> 
Sätt en penna mellan tänderna, (inte mellan läpparna). När du biter aktiveras samma muskler som när du ler och det skickar positiva signaler till hjärnan.  
</p><p class="text-center"> 
<h5 class="welcome">Busa</h5> 
Överraska med lösmustasch och lösnäsa vid frukosten, förställ rösten och grimasera på morgonmötet, brotta ner mannen och kittla honom när du kommer hem från jobbet. 
</p><p class="text-center"> 
<h5 class="welcome">Yoga!</h5> 
Samla ihop några du vill skratta med. Stå i en ring med framåtlutad kropp, som ett lejon. Håll händerna, med utspända fingrar, på varsin sida om huvudet som en lejonman och spärra upp ögonen, öppna munnen maximalt och sträck ut tungan nedåt så långt det går.  Sådärja - nu är det bara att börja skrikskratta. Och var så lugn, det smittar!
</p>
       </main>
     </section>


  </Layout2>
)

export default IndexPage
